import { Office } from "../redux/types";

export function getOfficeAddress(office: Office) {
  if (!office || !office.type) return "";
  switch (office.type) {
    case "INP":
      return office.address;
    case "TEL":
      return "مطب تلفنی";
    case "ONL":
      return "مطب آنلاین";
    case "VID":
      return "مطب آنلاین تصویری";
    case "FOR":
      return "آنلاین خارج از کشور";
    default:
      return "";
  }
}

export function getOfficeType(office: Office) {
  if (!office || !office.type) return "";
  switch (office.type) {
    case "INP":
      return "حضوری";
    case "TEL":
      return "مطب تلفنی";
    case "ONL":
      return "مطب آنلاین";
    case "VID":
      return "مطب آنلاین تصویری";
    case "FOR":
      return "آنلاین خارج از کشور";
    default:
      return "";
  }
}

export function getOfficeDescription(office: Office) {
  const officeName = getOfficeAddress(office);
  getOfficeAddress(office);
  if (office.type === "INP") {
    return `${officeName.includes("-") ? officeName.substring(0, office.address.indexOf("-")) : officeName}`;
  }
  return officeName;
}
